export const intercomIframeSandbox =
  "allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox allow-downloads";

export type IntercomBootMessage = {
  type: "3b-intercom-boot";
  email: string;
  name: string;
  userJwt?: string;
  company: { id: string; name: string };
  path: string;
  colorScheme: "light" | "dark";
};

export type IntercomShowMessage = { type: "3b-intercom-show" };

export type IntercomNavigateMessage = {
  type: "3b-intercom-navigate";
  path: string;
};

export type IntercomThemeMessage = {
  type: "3b-intercom-theme";
  colorScheme: "light" | "dark";
};

export type IntercomVisibilityMessage = {
  type: "3b-intercom-visibility";
  visible: boolean;
};

export type IntercomReadyMessage = {
  type: "3b-intercom-ready";
  appId?: string;
};

export type IntercomUnreadMessage = {
  type: "3b-intercom-unread";
  count: number;
};
